<template>
  <div class="section section6">
    <h2 class="fs24 fs-rem28 c-black sec-tit">
      <em></em>科创平台
    </h2>
    <div class="w1200">
      <div class="sec6-list">
        <ul class="list-box">
          <li class="lst-item lst-item1" @click.stop="onQueryData('yidaiyilu')">
            <a href="javascript:;" class="lst-link ex1">
              <i class="icon3 icon31"></i>
              <h3 class="fs16 fs-rem24 h3tit">一带一路</h3>
            </a>
          </li>
          <li class="lst-item lst-item2" @click.stop="onQueryData('difangchanye')">
            <a href="javascript:;" class="lst-link ex1">
              <i class="icon3 icon32"></i>
              <h3 class="fs16 fs-rem24 h3tit">地方产业</h3>
            </a>
          </li>
          <!-- <li class="lst-item lst-item3">
            <a href="###" class="lst-link">
              <i class="icon3 icon33"></i>
              <h3 class="fs16 fs-rem24 h3tit">科创平台</h3>
            </a>
          </li> -->
        </ul>
        <!-- <ul class="list-imgs">
          <li class="lst-item">
            <a href="####" class="lst-img">
              <img src="../../assets/_other/_img61.png" class="img" />
              <div class="lst-img-layer">
                <span class="txt">查看</span>
              </div>
            </a>
          </li>
        </ul> -->
        <div class="list-imgs swiper-container swiperOrg">
          <div class="swiper-wrapper" style="transition-duration: 0ms;">
            <div v-for="(org, index) in orgs" :key="index" class="lst-item swiper-slide" :data-swiper-slide-index="index">
              <a :href="org.url" class="lst-img">
                <img :src="formatImg(org.img)" class="img" />
                <div class="lst-img-layer">
                  <span class="txt">查看</span>
                </div>
              </a>
            </div>
          </div>
          <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
      </div>
    </div>
  </div>
  <!-- /科创平台 -->
</template>

<script>
  import {
    queryOrglist
  } from '@/api/main';
  import {
    formatImgSrc
  } from '@/utils/format';
  import Swiper from 'swiper';
  import GetStaticIndexMixin from '@/mixins/GetStaticIndex.mixin.js'
  import {
    StaticIndexConfig
  } from '@/const/StaticIndexConfig.js'
  export default {
    mixins: [GetStaticIndexMixin],
    name: 'ScientificPlatform',
    props: {
      msg: String,
    },
    data() {
      return {
        orgs: [],
        selected: "yidaiyilu"
      }
    },
    mounted() {

    },
    methods: {
      p_init() {
        this.initData('kechuangpingtai')
        new Swiper('.swiperOrg', {
          loop: true,
          slidesPerView: 5,
          initialSlide: 0,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
        this._queryOrglist();
      },
      onQueryData(tid) {
        if (tid === 'more') {
          this.more()
          return
        }
        this.orgs = []
        this.selected = tid;
        this._queryOrglist();
      },
      formatImg(img) {
        return formatImgSrc(img)
      },
      formatData(list = []) {
        list.forEach(element => {
          element.logo = formatImgSrc(element.logo);
          return element;
        });
        return list;
      },
      _queryOrglist() {
        // this.$http.get(queryOrglist()).then((res) => {
        //   console.log(res, '>queryOrglist');
        //   this.orgs = this.formatData(res.data);

        // });
        console.log('this.selected-----', this.selected)
        this.orgs = this.StaticIndexs[this.selected];
      },
    }
  };
</script>

<style>
  @import url(./ScientificPlatform.css);

  .ex1 {
    float: left;
    margin: 15px;
    -webkit-transition: margin 0.5s ease-out;
    -moz-transition: margin 0.5s ease-out;
    -o-transition: margin 0.5s ease-out;
  }

  .ex1:hover {
    margin-top: 2px;
  }
</style>
